import { StatusCard } from "./StatusCard";

interface RestrictedAccessProps {
  description?: string;
  className?: string;
}

export const RestrictedAccess = ({
  description = "This feature is reserved for account administrators. Please contact your internal admin to update your permissions.",
  className,
}: RestrictedAccessProps) => {
  return (
    <StatusCard
      title="Restricted Access"
      description={description}
      tone="warning"
      className={className}
    />
  );
};
